module.exports = __webpack_public_path__ + "static/media/logo.188b8d13.png";